<script setup lang="ts">
import MessagePlain from '@/views/chat/components/message-plain.vue'
import { computed } from 'vue'
import type { IResponseMixed, ResponseMessageTType } from '@/types'
import { useMessageComponent } from '@/views/chat/components/composition'

const props = defineProps<{ data: ResponseMessageTType<IResponseMixed> }>()
defineEmits(['message-click'])
const { plainAttrs } = useMessageComponent(props.data)
const list = computed(() => {
  return props.data?.tbcResponses.responses || []
})
</script>

<template>
  <message-plain class="message-guess" v-bind="plainAttrs">
    <div class="guess">
      <div class="title font-2">猜你想问</div>
      <template v-for="item in list">
        <div class="link font-1" @click="$emit('message-click', item.description)">{{ item.description }}</div>
      </template>
    </div>
  </message-plain>
</template>

<style scoped lang="scss">
.message-guess {
  ::v-deep(.title) {
    margin-bottom: 0 !important;
  }

  .guess {
    width: 12.5rem;
  }

  .title {
    margin-bottom: 0.4rem;
    color: #10394f;
  }

  .link {
    color: #0091df;
    padding: 0.4rem 0;

    + .link {
      border-top: 1px solid #393d45;
    }
  }
}
</style>
